module.exports = __webpack_public_path__ + "img/country_white_grey_ba_list.d6233e12.jpg";